import React, {createContext, FC, ReactElement, useEffect, useState} from "react";
import WhatsNew from "../../newComponents/Shared/WhatNew/WhatsNew";
import InstructorSummary from "../../newComponents/Instructor/InstructorSummary";
import * as globalTypes from "../../Store/global/constants";
import {sendWorkbook} from "../../Store/global/actions";
import {useDispatch, useSelector} from "react-redux";
import {makeSelectActiveStudent} from "../../Store/students/selectors";
import {makeSelectActiveLocation} from "../../Store/locations/selectors";
import {makeSelectCurrentUser} from "../../Store/user/selectors";
import {getCurrentUser, getOnlyCurrentUser} from "../../Store/user/actions";

interface IHeaderContext {
  title: string;
  icon: IconType;
  headerTabs: Tab[];
  activeTab: string;
  isBackButton: boolean;
  disabledTab: boolean;
  handleOnChangeHeaderValue: (values: HeaderContextValue) => void;
  handleOnSetActiveTab: (id: string) => void;
}

export const HeaderContext = createContext<IHeaderContext>({} as IHeaderContext);

interface IProps {
  children: ReactElement;
}

const HeaderProvider: FC<IProps> = ({ children }) => {
  const [header, setHeader] = useState({
    title: "",
    icon: "" as IconType,
    isBackButton: false,
    headerTabs: [],
    activeTab: "",
    disabledTab: false
  });
  const currentLocation = useSelector(makeSelectActiveLocation);
  const currentUser = useSelector(makeSelectCurrentUser);

  const dispatch = useDispatch();

  const handleOnChangeHeaderValue = (values: HeaderContextValue) => {
    const exist = values?.headerTabs?.find((tab) => tab.key === header.activeTab);
    setHeader({
      ...header,
      ...values,
      activeTab: exist
        ? header.activeTab
        : values?.headerTabs?.length
        ? values?.headerTabs[0].key
        : ""
    });
  };

  const handleOnSetActiveTab = (tab: string) => {
    const action = header?.headerTabs?.find((headerTab) => headerTab.key === tab).action;
    if (action) {
        switch (action) {
            case globalTypes.SEND_WORKBOOK_EMAIL:
                const payload = {
                    location_id: currentLocation?.id,
                    user_id: currentUser.id
                };
                if (currentUser?.isWorkbook) {
                    dispatch(sendWorkbook(payload));
                }
                return;
        }
    } else {
        setHeader({ ...header, activeTab: tab });
    }
  };
  return (
    <HeaderContext.Provider
      value={{
        title: header.title,
        icon: header.icon,
        isBackButton: header.isBackButton,
        headerTabs: header.headerTabs,
        activeTab: header.activeTab,
        disabledTab: header.disabledTab,
        handleOnChangeHeaderValue,
        handleOnSetActiveTab
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export default HeaderProvider;
